// extracted by mini-css-extract-plugin
export var createdDate = "_ly-1";
export var divider = "_ly-2";
export var headerDivider = "_ly-3";
export var messagesCard = "_ly-0";
export var messagesContainer = "_ly-7";
export var messagesContainerWrapper = "_ly-4";
export var pointerCapturingButtonBoxes = "_ly-a";
export var showLeftPanelButton = "_ly-9";
export var showMoreButton = "_ly-c";
export var showMoreButtonContainer = "_ly-b";
export var summaryTitle = "_ly-6";
export var systemMessageCardWrapper = "_ly-d";
export var topButtons = "_ly-8";
export var withPadding = "_ly-5";